export default __webpack_public_path__ + "static/media/58t.dca5c176.jpg";